import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type StringContentSliceOptions = {
  name: string;
  initialContent?: string;
};

export function createStringContentSlice({ name, initialContent = '' }: StringContentSliceOptions) {
  return createSlice({
    name,
    initialState: { content: initialContent },
    reducers: {
      setContent(state, action: PayloadAction<string>) {
        state.content = action.payload;
      },
      clearContent(state) {
        state.content = initialContent;
      },
    },
  });
}

export function createSimpleSliceReducers<T>() {
  return {
    update: (state: T, action: PayloadAction<Partial<T>>) => {
      return { ...state, ...action.payload } as T;
    },
    reset: () => {
      return undefined as unknown as T;
    },
  };
}
